<template>
  <div class="login-dialog">
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" width="400px" center>
      <div class="dialogitem">
        <el-input :type="loginType === 0 ? 'number' : 'text'" placeholder="请输入手机号" v-model="username"
          @input="checkLength" class="num-input"></el-input>
        <div v-if="loginType === 1" class="dialoglabel">(支持用户名/手机/邮箱)</div>
      </div>
      <div class="dialogitem" v-if="loginType === 1">
        <el-input placeholder="请输入密码" v-model="password" type="password" clearable show-password
          @keyup.enter.native="handleLogin"></el-input>
      </div>
      <div class="dialogitem" v-if="loginType === 0">
        <div class="dialogiteml">
          <el-input placeholder="请输入图形验证码" v-model="imgcode" maxlength="10"></el-input>
        </div>
        <div class="dialogitemr">
          <div @click="refreshverification" v-html="verificationsvg" class="verification"></div>
        </div>
      </div>
      <div class="dialogitem" v-if="loginType === 0">
        <div class="dialogiteml">
          <el-input placeholder="请输入验证码" v-model="passcode" type="number" @input="checkPLength"
            class="num-input">></el-input>
        </div>
        <div class="dialogitemr">
          <el-button :disabled="send" @click="aginSend">{{ content }}</el-button>
        </div>
      </div>
      <div class="dialogitem" v-if="loginType === 0 || loginType === 1">
        <el-checkbox v-model="rememberAccount" />
        <div class="dialoglabel" @click="toggleRememberAccount">{{ loginType === 0 ? '记住手机号' : '记住账号' }}</div>
      </div>
      <div class="dialogitem" v-if="loginType === 0 || loginType === 1">
        <el-checkbox v-model="checked" />
        <div class="dialoglabel" @click="toggleChecked">
          请阅读并同意<el-link :underline="false" @click.stop="openClauseDialog('service')">《用户协议》</el-link>和<el-link
            :underline="false" @click.stop="openClauseDialog('privacy')">《隐私条款》</el-link>
        </div>
      </div>
      <div class="dialogitem">
        <el-button type="primary" @click="handleLogin" :loading="loading" :disabled="loginButtonDisabled">{{ loginType
          === 0 ? '注册&登录' : '登录'
        }}</el-button>
      </div>
      <div class="dialogitem dialogfoot">
        <div v-if="loginType === 0">
          <el-link @click="switchLoginType(1)">使用账号密码登录</el-link>
        </div>
        <div v-if="loginType === 1">
          <el-link @click="switchLoginType(0)">使用验证码登录</el-link>
        </div>
      </div>
      <div class="dialogitem errmsg" v-show="iserrmsg">手机号格式不正确</div>
      <div class="dialogitem errmsg" v-show="codeerrmsg">
        {{ codeerrcon }}
      </div>
    </el-dialog>

    <!-- 协议弹窗 -->
    <el-dialog :title="clauseTitle" :visible.sync="clauseDialogVisible" width="800px" center>
      <div class="clause-content" ref="clauseContent" v-html="clauseContent"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeClauseDialog">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserId, saveToken } from '@/api/ai/training';
import md5 from 'js-md5';
import {
  verificationLogin,
  accountLogin,
  getCodeImg,
  sendVerificationCode,
  getUserInfo,
  userRegister,
  getIP
} from '@/utils/tauri-http';
import agreementsData from '@/assets/agreements.json';
export default {
  name: 'LoginDialog',
  data() {
    return {
      dialogVisible: true,
      loading: false,
      loginType: 0, // 0: 验证码登录, 1: 账号密码登录
      username: '',
      password: '',
      passcode: '',
      imgcode: '',
      checked: false,
      rememberAccount: true,
      send: true,
      content: '发送验证码',
      totalTime: 60,
      verification: '',
      verificationsvg: '',
      iserrmsg: false,
      codeerrmsg: false,
      codeerrcon: '',
      imgKey: '', //this.generateRandomImgKey(),
      ipAddress: '',
      privacyClause: '',
      serviceAgreement: '',
      clauseDialogVisible: false,
      clauseTitle: '',
      clauseContent: '',
      lastWarningTime: 0
    }
  },
  computed: {
    dialogTitle() {
      return this.loginType === 0 ? '手机号登录' : '账号登录';
    },
    loginButtonDisabled() {
      if (this.loginType === 0) {
        return !this.passcode || this.passcode.length !== 6 || !this.username || this.username.length !== 11;
      } else {
        return !this.username || !this.password;
      }
    }
  },
  mounted() {
    // Load stored account information from localStorage
    try {
      const storedUsername = localStorage.getItem('loginUsername');
      const storedLoginType = localStorage.getItem('loginType');
      if (storedUsername && storedLoginType) {
        this.username = storedUsername;
        this.loginType = parseInt(storedLoginType);
        // 触发验证码按钮状态检查
        this.checkLength();
      }
      const storedChecked = localStorage.getItem('loginAgreedToTerms');
      if (storedChecked) {
        this.checked = storedChecked === 'true';
      }
    } catch (error) {
      console.error('Failed to load stored account information:', error);
    }
    this.initData();
  },
  beforeDestroy() {

  },
  methods: {
    async initData() {
      try {
        await this.fetchIPAddress();
        // 从本地缓存读取协议内容
        this.loadAgreementFromCache();
      } catch (error) {
        console.error('初始化数据失败:', error);
      }
    },

    // 从本地缓存加载协议
    loadAgreementFromCache() {
      try {
        const cachedPrivacy = localStorage.getItem('privacyClause');
        const cachedService = localStorage.getItem('serviceAgreement');
        if (cachedPrivacy) {
          this.privacyClause = cachedPrivacy;
        } else {
          // 如果缓存中没有，从 JSON 文件读取
          this.privacyClause = agreementsData.PrivacyClause || '';
        }
        if (cachedService) {
          this.serviceAgreement = cachedService;
        } else {
          // 如果缓存中没有，从 JSON 文件读取
          this.serviceAgreement = agreementsData.ServiceAgreement || '';
        }
      } catch (error) {
        console.error('加载缓存协议失败:', error);
      }
    },

    // 获取IP地址
    async fetchIPAddress() {
      try {
        const response = await getIP();
        console.log('获取IP地址返回:', response);
        if (response.success && response.data.code === 10000) {
          this.ipAddress = response.data.data;
          console.log('获取IP地址成功:', this.ipAddress);
          localStorage.setItem('userIPAddress', this.ipAddress);
          this.imgKey = md5(this.ipAddress + new Date().getTime());
          this.refreshverification();
        }
      } catch (error) {
        console.error('获取IP地址失败:', error);
      }
    },

    // 获取协议
    async fetchAgreement(code) {
      try {
        const response = await getAgreement(code);
        if (response.success && response.data.code === 0) {
          const content = response.data.data?.content || '';
          if (code === 'PrivacyClause') {
            this.privacyClause = content;
            // 保存到本地缓存
            localStorage.setItem('privacyClause', content);
          } else if (code === 'ServiceAgreement') {
            this.serviceAgreement = content;
            // 保存到本地缓存
            localStorage.setItem('serviceAgreement', content);
          }
        }
      } catch (error) {
        console.error(`获取${code === 'PrivacyClause' ? '隐私协议' : '用户协议'}失败:`, error);
      }
    },
    async refreshverification() {
      try {
        // 打印URL地址
        const baseURL = 'https://loginf.lawxp.com/';
        const url = baseURL + 'Auth/GetCodeImg?ImgKey=' + this.imgKey;
        console.log('获取图形验证码请求URL:', url);
        // 调用electronAPI获取图形验证码
        const response = await getCodeImg(this.imgKey);
        // if (response.success) {
        // 将base64图片数据转换为可显示的图片
        this.verificationsvg = `<img src="${response.data}" style="width: 100%; height: 100%; cursor: pointer;" />`;
        // }
      } catch (error) {
        console.error('获取图形验证码失败:', error);

      }
    },
    checkLength() {
      this.send = true;
      if (this.username.length > 11) {
        this.username = this.username.slice(0, 11);
      }
      if (this.username.length == 11) {
        if (/^1[3456789]\d{9}$/.test(this.username.replace(/\s/gi, ''))) {
          this.iserrmsg = false;
          if (this.totalTime == 60) {
            this.send = false;
          }
        } else {
          this.iserrmsg = true;
        }
      } else {
        this.iserrmsg = false;
      }
    },
    checkPLength() {
      if (this.passcode.length > 6) {
        this.passcode = this.passcode.slice(0, 6);
      }
    },
    countDown() {
      this.send = true;
      this.content = this.totalTime + "s后重新发送";
      let clock = setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "s后重新发送";
        if (this.totalTime <= 0) {
          window.clearInterval(clock);
          this.content = "重新发送";
          this.totalTime = 60;
          this.checkLength();
        }
      }, 1000);
    },
    aginSend() {
      if (this.checked) {
        if (this.username.length == 11 && /^1[3456789]\d{9}$/.test(this.username.replace(/\s/gi, ''))) {
          const now = Date.now();
          if (!this.imgcode) {
            if (now - this.lastWarningTime > 3000) {
              this.$message.error("请输入图形验证码");
              this.lastWarningTime = now;
            }
            return;
          }
          let num = new Date().getTime();
          let data = {
            mobilePhone: this.username.replace(/\s/gi, ""),
            Phone: "",
            Msg: "尊敬的用户，验证码：{0}，有效期10分钟，请勿泄漏给他人，如非本人操作，请忽略此消息。",
            DeviceType: "H5",
            Ip: this.ipAddress || "H5",
            Time: num,
            sign: md5(",H5," + this.ipAddress + ",," + num + "," + "JSU$E&H@F"),
            source: 20,
            imgCode: this.imgcode,
            imgKey: this.imgKey
          };
          // 打印URL地址和上传参数
          const baseURL = 'https://loginf.lawxp.com/';
          const url = baseURL + 'Auth/APPSendCode';
          console.log('发送验证码请求URL:', url);
          console.log('发送验证码上传参数:', data);
          // 使用electronAPI发送验证码
          sendVerificationCode(data)
            .then((res) => {
              console.log('发送验证码响应:', res);
              if (res.success) {
                if (res.data && res.data.code === 0) {
                  // 验证码发送成功，开始倒计时
                  this.countDown();
                  this.$message.success('验证码发送成功');
                } else {
                  this.refreshverification();
                  // 验证码发送失败，显示错误信息
                  this.$message.error(res.data?.message || '发送验证码失败，请稍后重试');
                }
              } else {
                this.$message.error(res.error || '发送验证码失败，请稍后重试');
              }
            })
            .catch((err) => {
              console.error('发送验证码失败:', err);
              this.$message.error('发送验证码失败，请稍后重试');
            });
        } else {
          this.iserrmsg = true;
        }
      } else {
        const now = Date.now();
        if (now - this.lastWarningTime > 3000) {
          this.$message.error("请先阅读并同意《用户协议》和《隐私条款》");
          this.lastWarningTime = now;
        }
      }
    },
    switchLoginType(type) {
      this.loginType = type;
      this.password = "";
      this.passcode = "";
      this.imgcode = "";
      this.codeerrmsg = false;
      this.iserrmsg = false;
      // if (type === 0) {
      //   this.refreshverification();
      // }
    },
    async handleLogin() {
      this.loading = true;
      try {
        if (this.loginType === 0) {
          // 验证码登录
          if (!this.checked) {
            const now = Date.now();
            if (now - this.lastWarningTime > 3000) {
              this.$message.error("请先阅读并同意《用户协议》和《隐私条款》");
              this.lastWarningTime = now;
            }
            this.loading = false;
            return;
          }
          if (!this.imgcode) {
            const now = Date.now();
            if (now - this.lastWarningTime > 3000) {
              this.$message.error("请输入图形验证码");
              this.lastWarningTime = now;
            }
            this.loading = false;
            return;
          }
          // 打印URL地址
          const baseURL = 'https://loginf.lawxp.com/';
          const url = baseURL + 'Auth/GetTokenByPhone';
          console.log('验证码登录请求URL:', url);
          // 调用验证码登录接口
          const num = new Date().getTime();
          const verificationResponse = await verificationLogin({
            mobilePhone: this.username.replace(/\s/gi, ""),
            Phone: "",
            Msg: "{0}",
            DeviceType: "H5",
            Ip: "H5",
            Time: num,
            // imgCode: this.imgcode,
            // imgKey: this.imgKey,
            sign: md5(this.passcode + ",H5,H5,," + num + "," + "JSU$E&H@F"),
            source: 13,
            Code: this.passcode
          });
          console.log('验证码登录响应:', verificationResponse);
          if (verificationResponse.success && verificationResponse.data.code === 0) {
            const token = verificationResponse.data.data.token;
            const nickName = verificationResponse.data.data.nickName;
            const userId = verificationResponse.data.data.userId;
            const mobilePhone = verificationResponse.data.data.mobilePhone;
            console.log('登录成功，用户ID:', userId);
            console.log('登录成功，昵称:', nickName, mobilePhone);
            // 调用注册接口 暂时去除
            // await this.userRegister(userId, mobilePhone, token);
            await this.processLoginSuccess(token);

          } else {
            this.codeerrcon = verificationResponse.data?.message || verificationResponse.error || '登录失败';
            this.codeerrmsg = true;
            // 登录失败，重新获取验证码并清空输入
            this.refreshverification();
            this.passcode = '';
            this.imgcode = '';
          }
        } else {
          // 账号密码登录
          if (!this.checked) {
            const now = Date.now();
            if (now - this.lastWarningTime > 3000) {
              this.$message.error("请先阅读并同意《用户协议》和《隐私条款》");
              this.lastWarningTime = now;
            }
            this.loading = false;
            return;
          }
          // 打印URL地址
          const baseURL = 'https://loginf.lawxp.com/';
          const url = baseURL + 'Auth/GteTokenByAccountPwd';
          console.log('账号密码登录请求URL:', url);
          // 调用账号密码登录接口
          const loginResponse = await accountLogin({
            ip: 'H5',
            loginName: this.username.replace(/\s/gi, ''),
            loginPwd: this.password,
            loginToken: '',
            score: 20
          });
          console.log('账号密码登录响应:', loginResponse);
          if (loginResponse.success && loginResponse.data.code === 0) {
            const token = loginResponse.data.data;
            await this.processLoginSuccess(token);
          } else {
            this.codeerrcon = loginResponse.data?.message || loginResponse.error || '登录失败，请检查用户名和密码';
            this.codeerrmsg = true;
          }
        }
      } catch (error) {
        console.error('登录失败:', error);
        this.$message.error('登录失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    async processLoginSuccess(token) {
      // Store account information if rememberAccount is true
      if (this.rememberAccount) {
        try {
          localStorage.setItem('loginUsername', this.username);
          localStorage.setItem('loginType', this.loginType.toString());
        } catch (error) {
          console.error('Failed to store account information:', error);
        }
      }
      // 打印URL地址
      const baseURL = 'https://loginf.lawxp.com/';
      const url = baseURL + 'F_UserInfo/GetUserInfoByToken';
      console.log('获取用户信息请求URL:', url);
      // 使用 token 获取用户信息
      let tokens = { token: token };
      const headers = {
        "authorization": `Bearer ${token}`,
        "accept": "application/json, text/plain, */*",
        "accept-language": "zh,en;q=0.9",
        "cache-control": "no-cache",
        "content-type": "application/json;charset=UTF-8"
      };
      console.log('传递给getUserInfo的headers:', headers);
      const userInfoResponse = await getUserInfo(tokens, headers);
      console.log('获取用户信息:', userInfoResponse);
      if (userInfoResponse.success && userInfoResponse.data?.code === 0) {
        const userInfoData = userInfoResponse.data?.data || {};
        if (userInfoData.userId) {
          console.log('获取到用户ID:', userInfoData.userId);
          const longUserId = userInfoData.userId;
          const nickname = userInfoData.nickName || '';
          // 调用getUserId方法获取短userId，最多重试5次
          try {
            let userIdResponse = null;
            let retryCount = 0;
            const maxRetries = 5;
            const retryDelay = 3000; // 3秒

            while (retryCount < maxRetries) {
              userIdResponse = await getUserId(longUserId);
              if (userIdResponse && userIdResponse.data) {
                console.log('获取到短用户ID:', userIdResponse.data);
                break; // 获取成功，跳出循环
              }

              retryCount++;
              if (retryCount < maxRetries) {
                console.log(`获取短用户ID失败，${retryDelay / 1000}秒后第${retryCount + 1}次重试...`);
                // 等待3秒后重试
                await new Promise(resolve => setTimeout(resolve, retryDelay));
              }
            }

            if (userIdResponse && userIdResponse.data) {
              const shortUserId = userIdResponse.data;
              // console.log('获取到短用户ID:', shortUserId);
              // 调用 saveToken 接口存储 token 值
              try {
                const saveTokenData = {
                  user_long_id: longUserId,
                  user_short_id: shortUserId,
                  token: `${token}`
                };
                // { code: 200, message: "success" }
                const saveTokenResponse = await saveToken(saveTokenData);
                console.log('存储 token 结果:', saveTokenResponse);

                // 只有 saveToken 成功（code=200且message=success）才执行后续操作
                if (saveTokenResponse && saveTokenResponse.code == 200) {
                  // 标记已完成electron登录，跳过store的initializeUser
                  sessionStorage.setItem('electronLoginCompleted', 'true');
                  // 设置Vuex store的userId
                  this.$store.commit('SET_USER_ID', shortUserId);
                  this.$store.commit('SET_USER_NAME', nickname);
                  // 关闭登录弹窗
                  this.$store.commit('SET_SHOW_LOGIN_DIALOG', false);
                  sessionStorage.setItem('fromOA', 'false'); //pc - token
                  // 存储用户信息到sessionStorage
                  sessionStorage.setItem('userId', JSON.stringify({ id: shortUserId, longId: longUserId, userName: nickname, webSearchEnable: true }));
                  // 存储token到sessionStorage
                  sessionStorage.setItem('pctoken', token);
                  // 同步到 localStorage 实现持久化登录
                  try { localStorage.setItem('fromOA', 'false'); localStorage.setItem('userId', sessionStorage.getItem('userId')); localStorage.setItem('pctoken', token); localStorage.setItem('_authCachedAt', Date.now().toString()); } catch (e) {}
                  // 跳转到AI智能体页面
                  this.$router.push({
                    path: '/ai/chat/1', //'/ai/agent',
                    query: { newchat: 0, userId: shortUserId, login: "electron" }
                  });
                  console.log('login URL:', window.location.href);
                } else {
                  console.error('存储 token 失败:', saveTokenResponse);
                  // this.$message.error('存储用户信息失败，请稍后重试');
                  // 存储 token 失败，重新获取验证码并清空输入
                  this.refreshverification();
                  this.passcode = '';
                  this.imgcode = '';
                }
              } catch (error) {
                console.error('调用 saveToken 接口失败:', error);
                this.$message.error('存储用户信息失败，请稍后重试');
                // 存储 token 失败，重新获取验证码并清空输入
                this.refreshverification();
                this.passcode = '';
                this.imgcode = '';
              }
            } else {
              console.error('获取短用户ID失败（已尝试5次）:', userIdResponse);
              this.$message.error('获取用户信息失败，请稍后重试');
              // 获取用户信息失败，重新获取验证码并清空输入
              this.refreshverification();
              this.passcode = '';
              this.imgcode = '';
            }
          } catch (error) {
            console.error('调用getUserId接口失败:', error);
            this.$message.error('获取用户信息失败，请稍后重试');
            // 获取用户信息失败，重新获取验证码并清空输入
            this.refreshverification();
            this.passcode = '';
            this.imgcode = '';
          }
        } else {
          console.error('未获取到用户ID:', userInfoData);
          this.$message.error('未获取到用户ID，请稍后重试');
          // 获取用户信息失败，重新获取验证码并清空输入
          this.refreshverification();
          this.passcode = '';
          this.imgcode = '';
        }
      } else {
        this.$message.error("登录失败，请重试");
        // 登录失败，重新获取验证码并清空输入
        this.refreshverification();
        this.passcode = '';
        this.imgcode = '';

      }
    },
    handleCancel() {
      this.dialogVisible = false;
    },

    // 打开协议弹窗
    openClauseDialog(type) {
      if (type === 'privacy') {
        this.clauseTitle = '隐私协议';
        this.clauseContent = this.privacyClause;
      } else if (type === 'service') {
        this.clauseTitle = '用户协议';
        this.clauseContent = this.serviceAgreement;
      }
      this.clauseDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.clauseContent) {
          this.$refs.clauseContent.scrollTo({ top: 0 });
        }
      });
    },

    // 关闭协议弹窗
    closeClauseDialog() {
      this.clauseDialogVisible = false;
    },

    // 生成32位十六进制随机字符串作为ImgKey
    generateRandomImgKey() {
      let result = '';
      const characters = '0123456789abcdef';
      const charactersLength = characters.length;
      for (let i = 0; i < 32; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },

    // 切换协议勾选状态
    toggleChecked() {
      this.checked = !this.checked;
      try {
        localStorage.setItem('loginAgreedToTerms', this.checked.toString());
      } catch (error) {
        console.error('Failed to store agreedToTerms:', error);
      }
    },

    // 切换记住账号勾选状态
    toggleRememberAccount() {
      this.rememberAccount = !this.rememberAccount;
    },

    // 调用注册接口
    async userRegister(userId, mobilePhone, token) {
      try {
        const registerData = {
          mobilePhone: mobilePhone || "",
          platType: 13,
          platform: "system_web",
          type: 41,
          userId: userId
        };

        const headers = {
          "authorization": `Bearer ${token}`,
          "content-type": "application/json;charset=UTF-8"
        };

        console.log('调用注册接口，参数:', registerData);
        console.log('注册接口headers:', headers);
        console.log('注册接口URL:', 'https://im.xinfushenghuo.cn/j_user/userRegister');

        // 调用注册接口
        const response = await userRegister(registerData, headers);
        console.log('注册接口响应:', response);

        if (response.success) {
          console.log('注册成功');
        } else {
          console.error('注册失败:', response.error || '注册失败');
        }
      } catch (error) {
        console.error('调用注册接口失败:', error);
      }
    }
  }
}
</script>

<style scoped lang="less">
.num-input ::v-deep .el-input__inner[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.num-input ::v-deep .el-input__inner[type="number"]::-webkit-outer-spin-button,
.num-input ::v-deep .el-input__inner[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.login-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
  }

  ::v-deep .el-dialog__header {
    text-align: center;
    padding-top: 30px;
  }

  ::v-deep .el-dialog__title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
  }

  ::v-deep .el-dialog__body {
    padding: 30px 40px;
  }

  ::v-deep .el-dialog__footer {
    padding-bottom: 30px;
  }

  .dialogitem {
    margin-bottom: 10px;
    position: relative;

    &.dialogfoot {
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;

      div {
        margin-left: 10px;
      }
    }

    &.errmsg {
      text-align: center;
      color: #f56c6c;
      font-size: 12px;
      margin-top: 0px;
    }

    &.forgot {
      text-align: right;
      margin-bottom: 10px;
    }

    &.dialogpassword {
      margin-bottom: 10px;

      .dialogpasslabel {
        font-size: 12px;
        color: #999;
        margin-top: 5px;
      }
    }
  }

  .dialogiteml {
    width: 70%;
    display: inline-block;
  }

  .dialogitemr {
    width: 28%;
    display: inline-block;
    vertical-align: top;
    margin-left: 2%;
  }

  .verification {
    width: 100%;
    height: 40px;
    cursor: pointer;
  }

  .dialoglabel {
    cursor: pointer;
    font-size: 12px;
    color: #999;
    margin-top: 5px;
  }

  ::v-deep .el-button {
    width: 100%;
    height: 40px;
    padding: 12px 2px;
    font-size: 12px;
  }

  ::v-deep .el-checkbox {
    font-size: 12px;

    +.dialoglabel {
      display: inline-block;
      margin-left: 5px;
      margin-top: 0;
    }
  }

  ::v-deep .el-link {
    font-size: 12px;
  }

  .clause-content {
    max-height: 500px;
    overflow-y: auto;
    line-height: 1.5;
  }
}
</style>
